import { type Message, StyledPillButton, strings, text } from "@quickpoint.me/shared";
import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { LocaleAtom } from "../../state/localeAtom";
import { HostId } from "../../state/atoms";

function ToggleStacksPanelButton() {
	useRecoilValue(LocaleAtom); // re-render on locale change
	const toAuthorBC = new BroadcastChannel(strings.broadcastChannel.author);
	const hostId = useRecoilValue(HostId);

	const toggle = () => {
		const message: Message = {
			hostId,
			type: "fileUploader",
			action: strings.messages.toggleStacksPanel,
		};
		toAuthorBC.postMessage(message);
	};

	useEffect(() => {
		return () => toAuthorBC.close();
	});

	return (
		<StyledPillButton data-testid="stacks-panel-toggle" onClick={toggle}>
			{text.ui.done}
		</StyledPillButton>
	);
}

export default ToggleStacksPanelButton;
